export interface PerformanceCardItem {
    label: string;
    keys: {
        percentage: string;
        value: string;
    };
}

export const PERFORMANCE_CARDS: PerformanceCardItem[] = [
    {
        label: 'PORTFOLIO_PERFORMANCE_CARD_YTD',
        keys: {
            percentage: 'returnYTDPercentage',
            value: 'returnYTD',
        },
    },
    {
        label: 'PORTFOLIO_PERFORMANCE_CARD_LAST_3Y',
        keys: {
            percentage: 'return3YPercentage',
            value: 'return3Y',
        },
    },
    {
        label: 'PORTFOLIO_PERFORMANCE_CARD_LAST_5Y',
        keys: {
            percentage: 'return5YPercentage',
            value: 'return5Y',
        },
    },
    {
        label: 'PORTFOLIO_PERFORMANCE_CARD_SINCE_INCEPTION',
        keys: {
            percentage: 'sinceInceptionPercentage',
            value: 'sinceInception',
        },
    },
];
